import * as React from 'react';

import {Link} from '../../../link/link';

import {DetailsList} from '../../details-list/details-list';

import {CompanyLead} from './company-lead';
import type {Lead} from './company-lead';

export type CompanyInfo = {
    url: string | null | undefined;
    location: string | null | undefined;
    industry: string | null | undefined;
    revenue: number | null | undefined;
    numEmployees: number | null | undefined;
};

type Props = CompanyInfo & {
    lead: Lead | null | undefined;
    onClose: () => void;
};

export function CompanyDetails(props: Props) {
    const details = [];
    if (props.url) {
        details.push({
            key: 'url',
            name: 'URL',
            value: (
                <Link href={`https://${props.url}`} variant='secondary' newTab={true}>
                    {props.url}
                </Link>
            ),
        });
    }
    if (props.location) {
        details.push({key: 'location', name: 'Location', value: props.location});
    }
    if (props.industry) {
        details.push({key: 'industry', name: 'Industry', value: props.industry});
    }
    if (props.revenue) {
        details.push({
            key: 'revenue',
            name: 'Revenue',
            value: `$${props.revenue.toLocaleString()}`,
            isFullWidth: false,
        });
    }
    if (props.numEmployees) {
        details.push({
            key: 'employees',
            name: 'Employees',
            value: props.numEmployees,
            isFullWidth: false,
        });
    }

    return (
        <>
            {props.lead && <CompanyLead {...props.lead} onClose={props.onClose} />}
            <DetailsList details={details} />
        </>
    );
}
